import React from "react";
import { FunctionField, ReferenceField } from "react-admin";

interface IUpdatedByRenewalStudentField {
  data: any;
}

const UpdatedByRenewalStudentField = ({
  data,
}: IUpdatedByRenewalStudentField) => {
  if (data.updatedBy?.role === "Parent") {
    return (
      <ReferenceField
        reference="parents"
        source="updatedBy.id"
        linkType={false}
      >
        <FunctionField
          render={(record: any) =>
            `${data.updatedBy?.role} - ${record.firstName} ${record.lastName}`
          }
        />
      </ReferenceField>
    );
  } else {
    return (
      <ReferenceField reference="users" source="updatedBy.id" linkType={false}>
        <FunctionField
          render={(record: any) => `${data.updatedBy?.role} - ${record.email}`}
        />
      </ReferenceField>
    );
  }
};

export default UpdatedByRenewalStudentField;
